import React, { useState, useEffect, useContext } from 'react';
import { Container, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { 
  FaBell, 
  FaCog, 
  FaUserCircle,
  FaHeart
} from 'react-icons/fa';
import axios from 'axios';
import AppContext from '../../context/AppContext';
import '../../assets/css/layout/admin/Header.css';

const Header = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [notifications, setNotifications] = useState([]);

  const viewLatestNotifications = (loggedInAdmin) => {
    const formData = new FormData();
    formData.append('weadmin_id', loggedInAdmin.id);

    axios.post(`${baseUrl}/admin/notifications/viewAllNotifications`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => {
      if (res.data.success === true) {
        const sorted = [...res.data.notifications].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setNotifications(sorted.slice(0, 3));
      }
    })
    .catch((err) => console.log(err));
  };

  useEffect(() => {
    const loggedInAdmin = JSON.parse(localStorage.getItem('adminData'));
    if (loggedInAdmin) {
      viewLatestNotifications(loggedInAdmin);
    }
  }, []);

  const handleDropdownToggle = (isOpen) => {
    if (isOpen) {
      const loggedInAdmin = JSON.parse(localStorage.getItem('adminData'));
      if (loggedInAdmin) {
        viewLatestNotifications(loggedInAdmin);
      }
    }
  };

  const notificationCount = notifications.filter(n => n.status === 'unread').length;

  // Navigate to full notifications page
  const handleViewAllNotifications = () => {
    navigate('/admin/notifications');
  };

  return (
    <header className="hdr-header">
      <Container fluid className="hdr-container">
        {/* Left Side - Project Name & Logo */}
        <div className="hdr-left-section">
          <div className="hdr-logo-wrapper">
            <div className="hdr-logo-icon">
              <FaHeart className="hdr-heart-icon" />
            </div>
            <div className="hdr-brand-info">
              <h1 className="hdr-project-name">Bridely</h1>
              <span className="hdr-tagline">Wedding Events</span>
            </div>
          </div>
        </div>

        {/* Right Side - Icons */}
        <div className="hdr-right-section">
          {/* Notifications Dropdown */}
          <Dropdown align="end" className="hdr-dropdown" onToggle={handleDropdownToggle}>
            <Dropdown.Toggle className="hdr-icon-btn" variant="link" id="notifications-dropdown">
              <FaBell className="hdr-icon" />
              {notificationCount > 0 && (
                <span className="hdr-badge">{notificationCount}</span>
              )}
            </Dropdown.Toggle>

            <Dropdown.Menu className="hdr-dropdown-menu hdr-notifications-menu">
              {/* Header */}
              <div className="hdr-dropdown-header">
                <h6 className="hdr-dropdown-title">Notifications</h6>
                <span className="hdr-notification-count">{notificationCount} new</span>
              </div>

              {/* Notifications List */}
              <div className="hdr-notifications-list">
                {notifications.length === 0 ? (
                  <div className="hdr-notification-item">
                    <div className="hdr-notification-content">
                      <p className="hdr-notification-message">No Notifications</p>
                    </div>
                  </div>
                ) : (
                  notifications.map((notification) => (
                    <div 
                      key={notification.id} 
                      className={`hdr-notification-item ${notification.status === 'unread' ? 'hdr-unread' : ''}`}
                    >
                      <div className="hdr-notification-icon">
                        <FaBell />
                      </div>
                      <div className="hdr-notification-content">
                        <h6 className="hdr-notification-title">{notification.title}</h6>
                        <p className="hdr-notification-message">{notification.descrption}</p>
                        <span className="hdr-notification-time">{notification.created_at?.slice(0, 10)}</span>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Footer - View All Button */}
              <Dropdown.Divider />
              <Dropdown.Item 
                className="hdr-view-all-btn" 
                onClick={handleViewAllNotifications}
              >
                View All Notifications
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* Settings Button (No Dropdown) */}
          {/* <button className="hdr-icon-btn" onClick={() => navigate('/settings')}>
            <FaCog className="hdr-icon hdr-settings-icon" />
          </button> */}

           {/* Profile Button (No Dropdown) */}
        <button
  className="hdr-profile-btn"
  onClick={() => navigate("/admin/profile")}
>
  <div className="hdr-profile-avatar">
    <FaUserCircle className="hdr-avatar-icon" />
  </div>
  <div className="hdr-profile-info">
    <span className="hdr-profile-role">Admin</span>
  </div>
</button>

        </div>
      </Container>
    </header>
  );
};

export default Header;